import { render, staticRenderFns } from "./WhatYouNeed.vue?vue&type=template&id=f9756728"
import script from "./WhatYouNeed.vue?vue&type=script&lang=js"
export * from "./WhatYouNeed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports